/**
 * Version of the onboarding flow that produced an analytics event.
 *
 * - `"v1.0"` — the original pre-flow-engine onboarding flow: zustand store,
 *   route-as-state, web-only sign-up funnel + post-auth insurance link.
 * - `"v2.0"` — the flow-engine-based onboarding flow. Introduces the
 *   intent-selection question, intent-customized education screens, and a
 *   mobile-only post-auth notification permission step.
 */
export const ONBOARDING_VERSIONS = ["v1.0", "v2.0"] as const;

export type OnboardingFlowVersion = (typeof ONBOARDING_VERSIONS)[number];
